import * as THREE from "three";

// "punch" peaks fast then decays; "rumble" decays linearly; "roll" sine wave
export type ShakeCurve = "punch" | "rumble" | "roll";

type ShakeEvent = {
  intensity: number;
  remaining: number;
  duration: number;
  curve: ShakeCurve;
};

export class ScreenShake {
  private readonly events: ShakeEvent[] = [];
  private readonly offset = new THREE.Vector3();

  trigger(intensity: number, duration: number, curve: ShakeCurve = "rumble"): void {
    this.events.push({ intensity, duration, remaining: duration, curve });
  }

  update(dt: number): THREE.Vector3 {
    this.offset.set(0, 0, 0);
    for (let i = this.events.length - 1; i >= 0; i--) {
      const e = this.events[i]!;
      e.remaining -= dt;
      if (e.remaining <= 0) {
        this.events.splice(i, 1);
        continue;
      }
      const t = e.remaining / e.duration; // 1→0 as event plays out
      let amp: number;
      switch (e.curve) {
        case "punch":
          // Quick spike then fast decay: high at start (t≈1), drops sharply
          amp = e.intensity * Math.pow(t, 0.35);
          break;
        case "roll":
          // Sine-modulated rumble — feels like sustained engine buffet
          amp = e.intensity * t * (0.6 + 0.4 * Math.abs(Math.sin(t * Math.PI * 6)));
          break;
        default: // rumble — linear decay
          amp = e.intensity * t;
      }
      this.offset.x += (Math.random() - 0.5) * amp;
      this.offset.y += (Math.random() - 0.5) * amp;
    }
    return this.offset;
  }
}
